import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { UPSEItem } from "../Components/UPSEItem";
import TuneTwoToneIcon from "@mui/icons-material/TuneTwoTone";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import { addEspaceCharacters, constantes, instance } from "../Components/config";
import { useEffect, useState } from "react";
import { DialogAlert } from "../Components/DialogAlert";
import { DropDownList } from "../Components/DropDownList";
import { DatePicker } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import { EmptyResult } from "../Components/EmptyResult";
import { LoaderBox } from "../Components/LoaderBox";

function UPSEBuscador() {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  //const [item, setItem] = useState({ type: "", id: "", activo: "" });
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [upseInfo, setUpseInfo] = useState({});
  const [tipoDeEje, setTipoDeEje] = useState({ Id: "", Nombre: "" });
  const [eje, setEje] = useState({ Id: "", Nombre: "" });

  const [openFilter, setOpenFilter] = useState(false);
  function populateTable() {
    instance
      .get("/upse/listAll/")
      .then((res) => {
        setItems(res.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  }
  if (isLoading) {
    populateTable();
  }
  useEffect(() => {}, [openFilter]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpseInfo({
      [name]: value,
    });
  };
  const handleSubmitShort = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      nombre: addEspaceCharacters(info.nombre.value),
      anio: "",
      tipoDeEje: "",
      eje: "",
      cooperacion: "",
      signo: "",
      presupuesto: "",
      operativo: "",
      estrategico: "",
    };
    instance
      .post("upse/listFilter", form)
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      nombre: addEspaceCharacters(info.nombre.value),
      anio: info.anio.value,
      tipoDeEje: tipoDeEje.Id,
      eje: eje.Id,
      cooperacion: info.cooperacion.value,
      signo: info.signo.value,
      presupuesto: info.presupuesto.value,
      operativo: addEspaceCharacters(info.operativo.value),
      estrategico: addEspaceCharacters(info.estrategico.value),
    };
    instance
      .post("upse/listFilter", form)
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      });
  };
  return (
    <LoaderBox isLoading={isLoading}>
      <Container maxWidth="lg" sx={{ display: "flex", marginTop: 2 }}>
        <Grid container sx={{ display: "flex", flexDirection: "row" }}>
          <Grid
            container
            sx={{ display: openFilter ? "flex" : "none" }}
            spacing={2}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                id="nombre"
                label="Nombre"
                type="search"
                variant="standard"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <DatePicker
                views={["year"]}
                margin="standard"
                fullWidth
                id="anio"
                label="Año que planifica"
                name="anio"
                format="YYYY"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl>
                <FormLabel>Cooperación Externa</FormLabel>
                <RadioGroup row name="cooperacion" onClick={handleInputChange}>
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Sí"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <DropDownList
                title="Tipo de Eje"
                endpoint={"/tipoDeEje/listActive"}
                selectedItem={tipoDeEje}
                setSelectedItem={setTipoDeEje}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <DropDownList
                title="Eje"
                endpoint={
                  tipoDeEje.Id !== ""
                    ? `/eje/listActive/${tipoDeEje.Id}`
                    : undefined
                }
                selectedItem={eje}
                setSelectedItem={setEje}
                disabled={tipoDeEje.Id === ""}
                hierarchyUpdated={tipoDeEje}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: "flex", flexDirection: "row" }}
              gap={2}
            >
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel id="signoLabel">Signo</InputLabel>
                  <Select id="signo" name="signo" label="Signo">
                    <MenuItem value="1">=</MenuItem>
                    <MenuItem value="2">{"<="}</MenuItem>
                    <MenuItem value="3">{">="}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  variant="standard"
                  margin="normal"
                  fullWidth
                  id="presupuesto"
                  label="Techo presupuestario"
                  name="presupuesto"
                  type="number"
                  inputProps={{
                    step: constantes.decimales_dinero,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Q</InputAdornment>
                    ),
                  }}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="estrategico"
                name="estrategico"
                label="Objetivo Estratégico"
                type="search"
                variant="standard"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="operativo"
                name="operativo"
                label="Objetivo Operativo"
                type="search"
                variant="standard"
                fullWidth
              />
            </Grid>

            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
              spacing={4}
            >
              <Grid
                item
                xs={6}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  alignContent: "flex-end",
                }}
              >
                <Box>
                  <IconButton type="submit" variant="contained" padding={1}>
                    <SearchTwoToneIcon /> Buscar
                  </IconButton>
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  alignContent: "flex-end",
                }}
              >
                <Box>
                  <IconButton onClick={() => setOpenFilter(!openFilter)}>
                    <CloseIcon /> Cerrar Filtros
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              display: openFilter ? "none" : "flex",
              flexDirection: "row",
              gap: 2,
            }}
            xs={12}
            component="form"
            onSubmit={handleSubmitShort}
          >
            <Tooltip title="Filtros">
              <IconButton onClick={() => setOpenFilter(!openFilter)}>
                <TuneTwoToneIcon />
              </IconButton>
            </Tooltip>
            <TextField
              id="nombre"
              name="nombre"
              label="Nombre"
              type="search"
              variant="standard"
              fullWidth
            />
            <Tooltip title="Buscar">
              <IconButton type="submit">
                <SearchTwoToneIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Container>
      {items.map((item, index) => {
        return (
          <UPSEItem
            id={item.id}
            nombre={item.nombre}
            anio={item.anio}
            responsable={item.responsable}
            cooperacion={item.cooperacion}
            techo={item.presupuesto}
            tipoEje={item.tipoEje}
            eje={item.eje}
            key={index}
          />
        );
      })}

      {!isLoading && items.length === 0 && (
        <EmptyResult principal="No hay resultados que coincidan con la búsqueda" />
      )}
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { UPSEBuscador };
